import session from "../../../../services/session";
import swal from "sweetalert2";
import AdminApi from '../../../../services/api'
import CONFIG_COMPANY from "../../../../services/myConfig";
import Loc from "../../../../services/localization";

const AdminApiService = new AdminApi();
const LocService = new Loc()

export default {
    data() {
        return {
            locale: LocService,
            paymentId: 0,
            debtor : 0,
            additionalTypes: [],
            locations: [],
            selectedLocation: null,
            towel: false,
            enableMakingBills: false,
            showMemberShipForProgram: CONFIG_COMPANY.SHOW_MEMBERSHIP_FOR_PROGRAMS != null ? CONFIG_COMPANY.SHOW_MEMBERSHIP_FOR_PROGRAMS : false,
            model: {
                expireDate: null,
                paidDate: null,
                paidMoney: 0,
                isForCompany: false,
                invoiceLink: '',
                comment: '',
                types: [],
                additionalService: false,
                forProgram: false,
                selectedLocationForBill: null,
                paidWith: 'CASH'
            },
            paymentTypes: [],
            STANDARD: {
                id: 1,
                label: LocService.t('label_standard_payment'),
                value: false
            },
            ADDITIONAL_SERVICE: {
                id: 2,
                label: LocService.t('label_additional_payment'),
                value: true
            },
            kits: [],
            allKits: [],
            types: [],
            showConcreteValueForPayment: false,
            showPaymentInvoiceLink: false,
        }
    },
    methods: {
        editPayment: editPayment,
        loadPayment: loadPayment,
        openAdditionalKit: openAdditionalKit,
        openTrainingTypes: openTrainingTypes,
        formatDate: formatDate,
        generateKits: generateKits,
        getTrainingTypes: getTrainingTypes,
        detectIfSomeTypeNotExistAnyMore: detectIfSomeTypeNotExistAnyMore,
        getAdditionalKits: getAdditionalKits,
        onChangeCheckBox: onChangeCheckBox,
        onChangeCheckBoxKits: onChangeCheckBoxKits,
        setSelectedCheckBoxKits: setSelectedCheckBoxKits,
        selectLocation: selectLocation,
        selectPaidWith: selectPaidWith,
        setSelectedCheckBox: setSelectedCheckBox,
        isMainAdmin() {
            let value = localStorage.getItem('IS_MAIN_ADMIN');
            return value == null ? false : value === 'true' || value === true;
        },
    },
    beforeMount() {
        if (session.getRole() !== 'ROLE_ADMIN' && session.getRole() !== 'ROLE_SUPER_ADMIN' && session.getRole() !== 'ROLE_TRAINER') {
            this.$router.push(CONFIG_COMPANY.HOME);
            return;
        }
        this.enableMakingBills = session.getConfig().enableMakingBills != null ? session.getConfig().enableMakingBills : false;
        if(session.getConfig().customCategories != null && this.enableMakingBills){
            this.locations = session.getConfig().customCategories.split(";").filter(e => e.length > 0);
            let userLocation = session.getUserLocation();
            if(userLocation != null && userLocation.length > 0){
                this.locations = this.locations.filter(l => userLocation.includes(l));
            }
            if(this.selectedLocation == null && this.locations.length > 0){
                this.selectedLocation = this.locations[0];
            }
        }
        this.paymentId = this.$route.query.id;
        this.getAdditionalKits();
        this.loadPayment();
        // this.getTrainingTypes();
        if(session.getConfig().showConcreteValueForPayment != null){
            this.showConcreteValueForPayment = session.getConfig().showConcreteValueForPayment;
            if(this.showConcreteValueForPayment){
                this.model.paidMoney = 0;
            }
        }
        if(session.getConfig().additionalServiceTypes != null && session.getConfig().additionalServiceTypes.length > 0){
            this.additionalTypes = session.getConfig().additionalServiceTypes.split(";").filter(e => e.length > 0)
        }
        if(session.getConfig().showPaymentInvoiceLink != null){
            this.showPaymentInvoiceLink = session.getConfig().showPaymentInvoiceLink;
        }
    }
}

function selectLocation(location){
    this.selectedLocation = location;
}

function selectPaidWith(value){
    this.model.paidWith = value;
}

function generateKits(){
    if(this.kits.length === 0) return '';
    var i = 0;
    var kit = '';
    for(i = 0; i < this.kits.length; i++){
        kit = kit + this.kits[i] + ';'
    }
    return kit;
}

function editPayment() {
    let _self = this;
    if(_self.model.types.length === 0){
        swal(LocService.t('label_error'), LocService.t('label_payment_error_choose_type'), 'error')
        return;
    }
    if(!_self.showConcreteValueForPayment){
        _self.model.paidMoney = _self.debtor;
    }
    _self.model.paidMoney = this.model.paidMoney;
    _self.model.paidDate = this.model.paidDate + 'T00:00:00.000Z';
    _self.model.expireDate = this.model.expireDate + 'T00:00:00.000Z';
    _self.model.additionalKit = this.generateKits();
    _self.model.selectedLocationForBill = _self.selectedLocation
    swal({
        title: "",
        text: "",
        type: "",
        // html: "<div style='position: relative'><div class=\"loader\"></div></div>",
        html: "<div style='margin-top: 20%;' class=\"lds-roller\"><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div></div><div>Molimo sačekajte</div>",
        showCancelButton: false,
        showConfirmButton: false,
        allowOutsideClick: false,
        allowEscapeKey: false,
        customClass: 'swal-custom'
    }, function (selection) {
    });
    AdminApiService.updatePayment(_self.model, _self.paymentId)
        .then((response) => {
            swal(LocService.t('label_success'), LocService.t('label_payment_success_edit'), 'success')
            this.$router.back()
        })
        .catch(error => {
            swal(LocService.t('label_error'), error.data.localized_error_message, 'error')
        })
}

function loadPayment() {
    let _self = this;
    AdminApiService.getPaymentById(this.paymentId)
        .then((response) => {
            _self.model = response.data
            if(response.data.paidMoney > 0){
                _self.debtor = 1
            }else {
                _self.debtor = 0
            }
            _self.model.paidMoney = response.data.paidMoney
            _self.model.forProgram = response.data.forProgram != null ? response.data.forProgram : false;
            _self.model.expireDate = _self.formatDate(_self.model.expireDate)
            _self.model.paidDate = _self.formatDate(_self.model.paidDate)
            _self.model.types = response.data.trainingTypes.split(',')
            _self.model.isForCompany = response.data.isPayedForCompany;
            _self.model.invoiceLink = response.data.invoiceLink;
            _self.model.additionalService = response.data.additionalService;
            _self.model.paidWith = response.data.paidWith != null ? response.data.paidWith : 'CASH';
            _self.paymentTypes.push(_self.model.additionalService ? _self.ADDITIONAL_SERVICE : _self.STANDARD)
            var kits = response.data.additionalKit != null ? response.data.additionalKit.split(";") : [];
            var i = 0;
            for(i = 0; i < kits.length; i++){
                if(kits[i].length > 0){
                    _self.kits.push(kits[i])
                }
            }
            _self.getTrainingTypes();
        })
        .catch(error => {
            swal(LocService.t('label_error'), error.data.localized_error_message, 'error')
        })
}

function detectIfSomeTypeNotExistAnyMore(){
    var newModels = [];
    this.model.types.forEach(e => {
        if(this.types[e] != null){
            newModels.push(e)
        }
    })
    this.model.types = newModels;
}


function getTrainingTypes() {
    let _self = this;
    AdminApiService.getTrainingTypes()
        .then((response) => {
            _self.types = response.data
            _self.detectIfSomeTypeNotExistAnyMore();
        })
        .catch(error => {
            console.log(error);
            swal(LocService.t('label_error'), error.data.localized_error_message, 'error')
        })
}

function setSelectedCheckBox(key) {
    return this.model.types.indexOf(key) > -1
}

function onChangeCheckBox(key) {
    let isChecked = document.getElementById(key).checked
    if(isChecked){
        if(this.model.types.indexOf(key) < 0){
            this.model.types.push(key);
        }
    }else{
        const index = this.model.types.indexOf(key);
        if (index > -1) {
            this.model.types.splice(index, 1);
        }
    }
}


function formatDate(date) {
    return this.$moment(new Date(date * 1000)).format('YYYY-MM-DD')
}

function getAdditionalKits(){
    let _self = this;
    AdminApiService.getAdditionalKit()
        .then((response) => {
            _self.allKits = response.data;
        })
        .catch(error => {
            swal(LocService.t('label_error'), error.data.localized_error_message, 'error')
        })
}

function onChangeCheckBoxKits(key) {
    let isChecked = document.getElementById(key).checked
    if(isChecked){
        if(this.kits.indexOf(key) < 0){
            this.kits.push(key);
        }
    }else{
        const index = this.kits.indexOf(key);
        if (index > -1) {
            this.kits.splice(index, 1);
        }
    }
}

function setSelectedCheckBoxKits(key) {
    return this.kits.indexOf(key) > -1
}

function openAdditionalKit(){
    this.$router.push('additional-kits')
}

function openTrainingTypes(){
    this.$router.push('training-types')
}



// WEBPACK FOOTER //
// ./src/components/Users/Payment/Edit/EditPayment.js